<script setup lang="ts">
import { useActivitiesStore } from '@/stores/useActivityStore'
import { useUserStore } from '@/stores/useUserStore'
import { onMounted } from 'vue'
import { useBoostCorePermissionStore } from '@/stores/useBoostCorePermissionStore'
import ActivityList from '@/components/features/activities/ActivityList.vue'
const activitiesStore = useActivitiesStore()
const userStore = useUserStore()
const boostCoreStore = useBoostCorePermissionStore()

onMounted(async () => {
  if (!userStore.userConnected?.id) await userStore.getUserByEmail(boostCoreStore.user?.email)
  if (userStore.userConnected?.id)
    await activitiesStore.getActivitiesByUserId(userStore.userConnected?.id)
})
</script>

<template>
  <activity-list></activity-list>
</template>
